<template>
  <Head></Head>
</template>
<script setup>
const props = defineProps({
  head: Object
});
useHead(props.head);
</script>
